import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'button',
    'panel',
  ];

  // Some state variables for our controller.
  static values = {
    grabbed: Boolean,
    startPosition: Number,
    movedBy: Number,
    animationID: Number,
  }

  connect() {
    // Bind the animate function to this object because
    // it's used as a callback.
    this.animate = this.animate.bind(this);
  }

  setInitialValues() {
    this.grabbed = false;
    this.movedBy = 0;
    delete(this.startPosition);
  }

  // toggle adds or removes the 'hidden'. The rest is handled by CSS.
  toggle() {
    // Set all the initial values.
    this.setInitialValues();

    this.panelTarget.classList.toggle('hidden');
  }

  // pointerDown is called when panel is clicked or grabbed.
  pointerDown(event) {
    event.preventDefault();

    this.grabbed = true;
    this.startPosition = event.clientY;

    // Start the animation until we remove the pointer.
    this.animationID = requestAnimationFrame(this.animate);
  }

  pointerUp(event) {
    event.preventDefault();

    // Stop the animation.
    cancelAnimationFrame(this.animationID)

    this.grabbed = false;

    // Check if we dragged the panel enough to fully close it.
    if (this.movedBy > 100) {
      this.toggle();
    }

    // Reset the moved by.
    this.movedBy = 0;
  }

  pointerMove(event) {
    event.preventDefault();

    const movedBy = event.clientY - this.startPosition;

    // If we scroll 'up' don't do anything.
    if (movedBy < 0) {
      return
    }

    this.movedBy = movedBy;
  }

  setPanelPosition(value = this.movedBy) {
    this.panelTarget.style.transform = `translateY(${value}px)`;
  }

  // Start the animation which renders the panel smoothly.
  animate() {
    this.setPanelPosition();

    // Only animate if we are currently in grabbing mode.
    if (!this.grabbed) { return }

    requestAnimationFrame(this.animate);
  }
}
